import { AppRouteNames } from "@/shared/@types/AppRouteNames";
import { FeatureFlag } from "@/shared/@types/FeatureFlag";
import { useAccountStore } from "@/shared/stores/AccountStore";
import { useFeatureFlagsStore } from "@/shared/stores/FeatureFlagsStore";
import type { RouteLocationNormalizedLoaded } from "vue-router";

const PageNotFoundView = () =>
  import("@/shared/views/PageNotFoundView/PageNotFoundView.vue");
const OverviewView = () =>
  import("@/app/account-app/overview/OverviewView/OverviewView.vue");
const ChangeEmailView = () =>
  import("@/app/account-app/change-email/ChangeEmailView/ChangeEmailView.vue");
const ChangePasswordView = () =>
  import("@/app/account-app/change-password/ChangePasswordView/ChangePasswordView.vue");
const ChangeProfileView = () =>
  import("@/app/account-app/change-profile/ChangeProfileView/ChangeProfileView.vue");
const ChangeBankDetailsView = () =>
  import("@/app/account-app/change-bank-details/ChangeBankDetailsView/ChangeBankDetailsView.vue");
const DeleteAccountView = () =>
  import("@/app/account-app/delete-account/DeleteAccountView/DeleteAccountView.vue");
const DocumentsView = () =>
  import("@/app/account-app/documents/DocumentsView/DocumentsView.vue");
const SupportCasesOverviewView = () =>
  import("@/app/account-app/support-cases-overview/SupportCasesOverviewView/SupportCasesOverviewView.vue");

export const routes = [
  {
    path: "",
    name: AppRouteNames.AccountOverview,
    component: OverviewView,
  },
  {
    path: "change-email",
    name: AppRouteNames.AccountChangeEmail,
    component: ChangeEmailView,
  },
  {
    path: "change-password",
    name: AppRouteNames.AccountChangePassword,
    component: ChangePasswordView,
  },
  {
    path: "change-profile",
    name: AppRouteNames.AccountChangeProfile,
    component: ChangeProfileView,
  },
  {
    path: "change-bank-details",
    name: AppRouteNames.AccountChangeBankDetails,
    component: ChangeBankDetailsView,
    beforeEnter: () => {
      const accountStore = useAccountStore();
      if (!accountStore.canStoreBankDetails)
        return AppRouteNames.AccountNotFound;

      return true;
    },
  },
  {
    path: "delete-account",
    name: AppRouteNames.AccountDeleteAccount,
    component: DeleteAccountView,
  },
  {
    path: "documents",
    name: AppRouteNames.AccountDocuments,
    component: DocumentsView,
    beforeEnter: () =>
      useFeatureFlagsStore().isFeatureEnabled(
        FeatureFlag.AccountAccessDocuments,
      )
        ? true
        : AppRouteNames.AccountNotFound,
  },
  {
    path: "support-cases",
    name: AppRouteNames.AccountSupportCasesOverview,
    props: (route: RouteLocationNormalizedLoaded) => ({
      supportCaseQueryNr: route.query.caseNumber,
    }),
    component: SupportCasesOverviewView,
  },
  {
    path: ":pathMatch(.*)*",
    name: AppRouteNames.AccountNotFound,
    component: PageNotFoundView,
    props: {
      homeRouteName: AppRouteNames.AccountOverview,
    },
  },
];
